import React, { forwardRef } from 'react';
import styles from './ButtonBar.module.css';
import Check from '@mui/icons-material/TaskAlt';

const ButtonBar = forwardRef(({ labels = [], colors = [], selectedLabel = "", onClick, filterRef }, ref) => {

	return (
		<div className={styles.buttonBar} ref={filterRef}>
			{labels.map((label, index) => (
				<button
					key={index}
					className={styles.button}
					style={{
						backgroundColor: colors[index]
					}}
					onClick={() => onClick(label, index)}
				>
					<Check
						sx={{
							fontSize: 24,
							marginRight: '4px',
							color: label === selectedLabel ? 'white' : 'transparent'
						}}
					/>
					{label}
				</button>
			))}
		</div>
	);
});

export default ButtonBar;